import React from 'react';

/* Hora a 12 horas: hora · minuto · a. m./p. m. (2026-10-06, en vez del reloj del navegador). El valor entra y sale
   como «HH:MM» de 24 h, igual que el <input type="time"> al que sustituye, así nada más cambia. */
const pad = (n) => String(n).padStart(2, '0');

export default function SelectorHora({ value, onChange, disabled, paso = 5, ariaLabel = 'Hora', testid, className = '' }) {
  const [h24, mi] = String(value || '09:00').split(':').map((x) => Number(x) || 0);
  const pm = h24 >= 12;
  const h = (h24 % 12) || 12;
  const minutos = [];
  for (let m = 0; m < 60; m += paso) minutos.push(m);
  if (!minutos.includes(mi)) minutos.push(mi); // una hora que no cae en el paso (p. ej. 10:07) no se pierde
  minutos.sort((a, b) => a - b);
  const emitir = (nh, nm, npm) => {
    const base = nh % 12;
    onChange?.(`${pad(npm ? base + 12 : base)}:${pad(nm)}`);
  };
  return (
    <span className={`cal-hora ${className}`} role="group" aria-label={ariaLabel} data-testid={testid}>
      <select className="cal-select cal-hora-parte" value={h} disabled={disabled} aria-label={`${ariaLabel}: hora`}
        onChange={(e) => emitir(Number(e.target.value), mi, pm)}>
        {[12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <span className="cal-hora-sep" aria-hidden="true">:</span>
      <select className="cal-select cal-hora-parte" value={mi} disabled={disabled} aria-label={`${ariaLabel}: minutos`}
        onChange={(e) => emitir(h, Number(e.target.value), pm)}>
        {minutos.map((m) => <option key={m} value={m}>{pad(m)}</option>)}
      </select>
      <select className="cal-select cal-hora-parte" value={pm ? 'pm' : 'am'} disabled={disabled} aria-label={`${ariaLabel}: a. m. o p. m.`}
        onChange={(e) => emitir(h, mi, e.target.value === 'pm')}>
        <option value="am">a. m.</option>
        <option value="pm">p. m.</option>
      </select>
    </span>
  );
}
